// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TZgNx","toggle":"styles_toggle__2A6l7","preview":"styles_preview__2IUeh"};